<div class="request-description-container">

  <div class="shared-information">
    <div class="header">
      <div class="title-container">
        <h3>{{ 'request_v2.info.shared_information' | translate }}</h3>
      </div>
    </div>

    <div class="files-grid">
      <div class="file-container" *ngFor="let file of request.files; let i = index">
        <div *ngIf="canEdit" class="delete-file-btn" (click)="removeFile(i); $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </div>
        <ng-container *ngIf="isImage(file)">
          <div class="file-preview" (click)="downloadFile(file)">
            <img [src]="file.url" [alt]="getFileName(file)">
          </div>
        </ng-container>
        <ng-container *ngIf="!isImage(file)">
          <div class="file-preview document-icon" (click)="downloadFile(file)">
            <img *ngIf="isDocumentPdf(file)" src="assets/images/pdf-file.svg" alt="PDF File">
            <img *ngIf="isDocumentWord(file)" src="assets/images/word-file.svg" alt="Word File">
            <img *ngIf="isDocumentExcel(file)" src="assets/images/sheets-file.svg" alt="Excel File">
            <mat-icon *ngIf="!isDocumentPdf(file) && !isDocumentWord(file) && !isDocumentExcel(file)">insert_drive_file</mat-icon>
          </div>
        </ng-container>
        <div class="file-name" [title]="getFileName(file)">{{ getFileName(file) }}</div>
      </div>

      <!-- Upload in progress placeholder -->
      <div class="file-container" *ngIf="isUploading">
        <div class="file-uploading"></div>
      </div>

      <div class="file-container" *ngIf="canEdit">
        <div class="add-file-btn"
             [class.drag-over]="isDragOver"
             [class.disabled]="isUploading"
             (click)="!isUploading && addFile()"
             (drop)="!isUploading && onDrop($event)">
          <ng-container *ngIf="!isDragOver">
            <mat-icon>add</mat-icon>
          </ng-container>
          <ng-container *ngIf="isDragOver">
            <mat-icon class="upload-icon">upload</mat-icon>
            <span class="upload-label">{{ 'request_v2.info.upload' | translate }}</span>
          </ng-container>
        </div>
      </div>
    </div>

    <input *ngIf="canEdit" type="file" #fileInput multiple style="display: none" (change)="onFileSelected($event)" accept="image/*,application/pdf">
  </div>

</div>
